export default {
  'en-US': {
    compareTable: {
      notIncluded: 'Not Included',
      included: 'Included',
    },
    cookieConsent: {
      p: 'This website uses cookies to improve your experience. By continuing to browse the site, you are agreeing to our use of cookies. Review our {link} for more details.',
      link: 'Privacy Policy',
    },
    copyright: `Copyright ${new Date().getFullYear()} Neat | All Rights Reserved`,
    cta: {
      buyNow: 'Buy now',
      buyNowRenew: 'Buy now - Save $50',
      buyNowRenewOffer: 'Buy now - Save $100',
      buyNowMigrationSupport: 'Buy now - Save $100',
      buyNowAndSave: 'Buy now and save $100',
      continue: 'Continue',
      close: 'Close',
      dismiss: 'Dismiss',
      finish: 'Finish',
      freeTrial: 'Free trial',
      getStarted: 'Get Started',
      keepMyFiles: 'Keep my files',
      learnMore: 'Learn more »',
      login: 'Log In',
      processing: 'Processing',
      seePlansAndPricing: 'See plans and pricing',
      signIn: 'Sign In',
      signUpNow: 'Sign up now',
      submit: 'Submit',
      submitting: 'Submitting...',
      subscribe: 'Subscribe',
      tryNeatFREE: 'Try Neat FREE',
      tryNeatFree: 'Try Neat Free',
      unsubscribe: 'Unsubscribe',
      getNotified: 'Get Notified',
      start14DayTrial: 'Start your 14-Day Trial',
      iWantTheOffer: 'Yes, I want the offer',
      tryNeatHome: 'Try NeatHome free',
      tryNeat: 'Try Neat',
      tryNeatTrial: 'Try Neat Trial',
      buyUnderSeven: 'Buy NeatHome now under $7/mo',
      voteAndEnter: 'Vote & Enter Now',
      uncoverDates: 'Uncover all dates',
      coverDates: 'Cover all dates',
      noCcTrial: 'START NO-CC TRIAL',
      tooManyAttempts: 'Return Home',
    },
    featuresFooter: {
      header: "Let's Get Started",
      p: 'Ready for more confidence?{br}Try Neat today for free.',
      smallText: "Neat's full suite platform offers a 30-day money back guarantee",
    },
    footer: {
      appStore: {
        alt: 'Download on the App Store',
        title: 'Apple App store - link to Neat app',
      },
      playStore: {
        alt: 'Get it on Google Play',
        title: 'Google Play store - link to Neat app',
      },
      bbbAlt: 'BBB Accredited Business',
      mailingList: {
        header: 'Subscribe',
        label: 'Subscribe to get tips and offers designed to help grow your business.',
      },
      navLists: {
        company: 'Company',
        product: 'Product',
        resources: 'Resources',
      },
      recaptchaTerms: 'This site is protected by reCAPTCHA and the Google {privacyLink} and {termsLink} apply.',
    },
    header: {
      features: 'Features',
      product: 'Product',
    },
    label: {
      email: 'Email',
      firstName: 'First Name',
      lastName: 'Last Name',
      password: 'Password',
      plan: 'Plan',
      phone: 'Mobile Number',
    },
    navLinks: {
      accountants: 'Accountants',
      accountingTerms: 'Accounting Terms Glossary',
      automatedInsights: 'Automated Insights',
      balanceSheetTemplate: 'Free Balance Sheet Template',
      webinars: 'Webinars',
      newsletter: 'Newsletter',
      blog: 'Blog',
      careers: 'Careers',
      features: 'Features',
      incomeStatementTemplate: 'Free Income Statement Template',
      helpCenter: 'Help Center',
      receiptsExpensesTaxesGuide: 'Receipts, Expenses & Taxes Guide',
      integrations: 'Integrations',
      invoiceTemplate: 'Free Invoice Template',
      learn: 'Learn',
      neatFeatures: 'Neat',
      ourHistory: 'About Neat',
      policies: 'Policy Center',
      pricing: 'Pricing',
      product: 'Product',
      productReleases: 'Product Releases',
      receiptDocumentScanners: 'Compatible Scanners',
      security: 'Security',
      support: 'Support',
      taxPrep: 'Prep Taxes',
      trackReceipts: 'Track Receipts',
      transactionStreaming: 'Reconcile',
      vipService: 'VIP Service',
      expenseManagementMobileApp: 'Mobile App',
      digitalFilingCabinet: 'Digital Filing Cabinet',
    },
    featureRows: {
      trackReceipts: {
        title: 'Track Receipts Everywhere',
        text: 'Capture receipts, invoices, and so much more with the snap of a picture. Then upload them straight to Neat using the app. Even email, drag and drop documents into Neat, or import with a compatible scanner.[br][br]You’ll always have access to your documents in Neat.',
      },
      dataExtraction: {
        title: 'Data Extraction',
        text: 'Reduce manual data entry with Neat’s powerful, patented OCR technology that accurately extracts key information from your document and turns it into usable data allowing you to enter receipts quickly and accurately.',
      },
      dataVerification: {
        title: 'Data Verification',
        text: 'Your receipt items are processed using Neat’s unique data identification technology and data is extracted with 99% accuracy.',
      },
      organizeFiles: {
        title: 'Organize Files Your Way',
        text: 'Organize files by expense type, tax category, and more. Quickly find files with our keyword search and filtering capabilities.',
      },
    },
    pages: {
      automatedInsights: {
        main: {
          header: {
            title: 'Automated Insights & Expenses',
            subtitle: 'Neat’s expense tracking software automatically categorizes and syncs your expenses, eliminating manual entry and helping you stay tax-ready.',
            smallPrint: 'Automated Insights cannot be purchased without a Neat subscription.',
            descriptionImgOne: 'Analyze your finances with live data',
            descriptionImgTwo: 'Easily monitor top expense categories & cash balances',
            altImgOne: 'Live data',
            altImgTwo: 'Monitor expense & cash',
          },
          features: {
            connectBankAccount: 'Manage all of your financial data in one place by importing all of your bank account(s) activity.',
            pairReceipts: "Use Neat's mobile app to upload and match receipts to expenses as they occur. Guided workflows are provided with suggested receipt matching to make accounting easy.",
            accountingReports: 'Make informed decisions with automatic, real-time accounting reports such as profit and loss statements, cash flow statements, balance sheets, and transaction reports.[br]Download and share reports with anyone who may need to view it for accounting or record keeping purposes.',
            realTimeInsights: 'Know what is going on in your business at a glance, with real-time insights - including net cash flow, top expense categories, cash balance, profit and loss, and total sales.',
            customInvoices: 'Send customized invoices within minutes.',
            onlinePayments: 'Stop waiting for checks in the mail. Receive safe and secure online payments by enabling your customers to pay you by bank transfers and credit/debit card*.',
          },
        },
      },
      careers: {
        header: {
          title: 'Come Work With Us',
          subtitle: 'Neat is a mixture of seasoned professionals and dynamic young leaders that together create a unique blend of experience and energy. Our employees combine humor with humility in a highly collaborative, open-office environment geared towards creative problem solving and rapid decision making.',
        },
        whatWeOffer: {
          title: 'What Do We Offer?',
          medical: {
            name: 'Medical, Dental, & Vision',
            p: 'Subsidized coverage for employees and families. Option for high-deductible plan with generously funded HSA plan.',
          },
          pto: {
            name: 'Paid Time Off',
            p: "We know committing to getting things done can impact your work-life balance. It's important to take the time to refresh.",
          },
          holidays: {
            name: 'Holidays',
            p: '9 paid company holidays and summer hours.',
          },
          transit: {
            name: 'SEPTA Ride Share',
            p: 'Tax-free transit',
          },
          salary: {
            name: 'Competitive Salary',
            p: 'Competitive salary, stock options and 401(k) with company match.',
          },
          environment: {
            name: 'Productive Environment',
            p: 'A casual, entrepreneurial environment of ownership and accountability, enabling you to get your work done. ',
          },
        },
        openings: {
          title: 'Openings',
          noOpenings: 'No openings at this time. Please check back later.',
        },
      },
      deleteAccount: {
        header: 'I Still Want to Delete My Account',
        confirmation: 'If you wish to have the account associated with your email address <strong>({email})</strong> completely deleted from the Neat application, then please press the button below.',
        cta: 'Delete account',
        unavailable: 'Account deletion is unavailable.',
        success: {
          received: 'Your account deletion request has been received and will be processed shortly.',
          note: 'Please note, account deletion requests can sometimes take upwards of 7-10 days. You will receive a confirmation via email once your account has been deleted.',
          email: 'Email Address: <strong>{email}</strong>',
        },
      },
      emailPreferences: {
        subscribe: {
          header: 'Subscribe',
          p1: 'Subscribe here to get tips and offers designed to help grow your business straight to your inbox.',
          p2: 'We send emails a few times a month, so once you subscribe you can expect to hear from us soon.',
          success: 'You have successfully subscribed to receive emails from Neat!',
        },
        unsubscribe: {
          header: 'Unsubscribe',
          p1: 'If you would like to unsubscribe from receiving marketing emails from Neat, you may opt out here. By opting out, you will no longer receive tips and offers from Neat. You will still receive important account and billing related emails from Neat.',
          success: 'Your opt-out request has been confirmed. Please allow 48 hours for your request to fully process. You can re-subscribe anytime by filling out the form above.',
        },
      },
      fbRenew: {
        main: {
          header: {
            title: 'A smarter way to manage your receipts and documents',
            subtitle: 'Simplify how you work',
          },
        },
        security: {
          title: '20 years of security and data protection',
          p: 'In tech world years, two decades equates to centuries. With that experience comes a deep knowledge of data security. Because we use the highest standard of bank-level encryption, your data is kept secure from any breaches.',
        },
      },
      home: {
        main: {
          header: {
            title: 'A smarter way to manage your receipts and documents',
            subheader: 'Effortlessly scan and organize receipts, invoices, and documents with Neat\'s document management scanner—your all-in-one solution for managing financial records seamlessly.',
          },
        },
        features: {
          title: 'Go Paperless with Neat Receipt Management',
          subtitle: 'Save time and get to what matters',
          description: 'Transform piles of receipts into organized, searchable digital records instantly with Neat\'s paperless document management system.',
          li1: 'Access real-time visibility into expenses, spending, sales, and income tax for easy filing and reporting.',
          li2: "Avoid manual data entry with Neat's patented technology that accurately extracts key information from your document.",
          li3: 'Upload receipts and documents securely with your mobile device or scanner.',
          cta: "Learn more about Neat's features",
          cabinetAlt: 'Neat File Management Screenshot',
        },
        quotes: {
          quote1: "“It pulls the information off the page, actually reads the text that's on there, and organizes it for you.“",
          authorPrefix: '-',
          author1: 'Josh Z., Certified Professional Organizer',
          quote2: "“It's simply more enjoyable to live in a space that's organized.“",
          author2: 'Bonnie D., Certified Professional Organizer',
          quote4: '“The system is fantastic and eliminates many hours of filing and finding files.“',
          author4: 'Andy K.',
          quote3: "“I have been using Neat for at least 7 years, and it's made tracking receipts and generating year end reports a breeze.“",
          author3: 'Joann D.',
          quote5: '“Makes end of the year filing so easy! No need to save receipts.“',
          author5: 'Michael K.',
        },
        stats: {
          waste: {
            stat: '92',
            unit: '%',
            details: 'waste time searching for important documents',
          },
          efficiency: {
            stat: '10',
            unit: 'X',
            details: 'more efficiency in searching for files',
          },
          protection: {
            stat: '100',
            unit: '%',
            details: 'file protection from natural disasters',
          },
          callout: {
            title: 'Join over 2 million small businesses',
            subtitle: 'who have trusted Neat services',
          },
        },
        security: {
          title: '20 years of security and data protection',
          p: 'In tech world years, two decades equates to centuries. With that experience comes a deep knowledge of data security. Because we use the highest standard of bank-level encryption, your data is kept secure from any breaches.',
        },
      },
      integrations: {
        main: {
          title: 'Integrations',
          subtitle: 'Seamless Receipt Scanner with Tax Integration',
          description: 'Neat connects your scanned receipts directly to tax software, making deductions easier and tax filing stress-free.',
          ctaHeader: 'No Setup Hassle – Connect Your Tools Instantly!',
          ctaText: 'Neat\'s receipt scanner with tax integration is built for small business owners—easy to connect, easy to use, and built to save time.',
          tabs: {
            support: '<strong>Visit our support center for more information on integrating {linkCount, plural, one {{link}} other {{link} or {link2}}}</strong>',
            quickbooks: {
              title: 'QuickBooks<sup>®</sup>',
              subtitle: 'Eliminate Data Entry With Neat and QuickBooks',
              description: 'Using Neat with QuickBooks Online simplifies accounting by reducing data entry and automatically organizing expenses.',
              li1: 'Review and send all expense-related data directly over to QuickBooks. Images of receipts and invoices are automatically attached.',
              li2: 'Sign in to QuickBooks from the Neat app to connect.',
              li3: 'Map expenses once to match your QuickBooks preferences and future data will map automatically.',
              supportLink: 'QuickBooks Online',
            },
            hrblock: {
              title: 'H&R Block<sup>®</sup>',
              subtitle: 'Simplify tax filings and maximize deductions with Neat with H&R Block',
              li1: 'Scan receipts and invoices to track expense documents throughout the year.',
              li2: 'Save time by eliminating the need to key in all data from expense-related documents.',
              li3: "Avoid potential errors with Neat's machine-learned data automation and send directly to H&R Block.",
              li4: 'Utilize tax categories in Neat throughout the year, and H&R Block will use that information to create your tax forms.',
              supportLink: 'H&R Block',
            },
            quicken: {
              title: 'Quicken<sup>®</sup>',
              subtitle: 'Simplify Accounting & Bookkeeping with Neat and Quicken.',
              li1: 'Scan receipts and invoices to track expenses throughout the year.',
              li2: 'Save time by eliminating the need to key in all data from expense-related documents.',
              li3: "Avoid potential errors with Neat's machine-learned data automation and send directly to Quicken.",
              supportLink: 'Quicken',
            },
            turbotax: {
              title: 'TurboTax<sup>®</sup>',
              subtitle: 'Simplify tax filings and maximize deductions with Neat and TurboTax.',
              li1: 'Scan receipts and invoices to track expenses throughout the year.',
              li2: 'Save time by eliminating the need to key in all data from expense-related documents.',
              li3: "Avoid potential errors with Neat's machine-learned data automation and send directly to TurboTax.",
              li4: 'Utilize tax categories in Neat throughout the year, and TurboTax will use that information to create your tax forms.',
              supportLink: 'TurboTax',
            },
            outlook: {
              title: 'Outlook<sup>®</sup>',
              subtitle: 'Never lose a contact again when you sync Neat with Outlook Contacts.',
              li1: 'Turn your stack of business cards into a digital contact list.',
              li2: 'Seamlessly forward contacts to Outlook Contacts.',
              li3: 'Organize contacts by project, event, region, and create a distribution list for sales emails.',
              li4: 'Utilize tax categories in Neat throughout the year, and TurboTax will use that information to create your tax forms.',
              supportLink: 'Outlook',
            },
            campaignMonitor: {
              title: 'Campaign Monitor<sup>®</sup>',
              subtitle: 'Focus on creating compelling campaigns and less on entering in contact information when you link Neat and Campaign Monitor.',
              li1: 'Automate and digitize your stack of business cards in minutes.',
              li2: 'Seamlessly forward contacts to specific email streams in Campaign Monitor.',
              li3: 'Organize contacts by project, event, region, and create a distribution list for sales emails.',
              supportLink: 'Campaign Monitor',
            },
            mailchimp: {
              title: 'MailChimp<sup>®</sup>',
              subtitle: 'Scan business cards with Neat to add contacts to your MailChimp Campaign.',
              li1: 'Automate and digitize your stack of business cards in minutes.',
              li2: 'Seamlessly forward contacts to specific email streams in MailChimp.',
              li3: 'Organize contacts by project, event, region and create a distribution list for sales emails.',
              supportLink: 'MailChimp',
            },
            googleContacts: {
              title: 'Google Contacts<sup>®</sup>',
              subtitle: 'Sync Neat with Google Contacts and never lose a contact again.',
              li1: 'Automate and digitize your stack of business cards in minutes.',
              li2: 'Seamlessly sync contacts to Google Contacts.',
              li3: 'Organize contacts by project, event, region, and create a distribution list for sales emails.',
              supportLink: 'Google Contacts',
            },
            constantContact: {
              title: 'Constant Contact<sup>®</sup>',
              subtitle: 'Use Neat with Constant Contact to spend less time on data entry and more time creating killer email campaigns.',
              li1: 'Automate and digitize your stack of business cards in minutes; or simply add them to Neat as you get them.',
              li2: 'Seamlessly forward contacts to specific email streams in Constant Contact.',
              li3: 'Organize contacts by project, event, region and create a distribution list for sales emails.',
              supportLink: 'Constant Contact',
            },
          },
        },
      },
      invoiceTemplate: {
        download: 'Download your free invoice and payment request templates',
        blogPost: 'blog post',
        tryNeatTool: {
          button: 'Start Invoicing Today',
        },
        featuresFooter: {
          header: 'Try Neat\'s Invoicing Tool',
          button: 'Start Invoicing Today',
          text: 'Invoicing + File Document/Receipt Management + Financial reporting',
        },
      },
      migrationSupport: {
        main: {
          header: {
            title: 'Migrate and store your Neat data with help from our VIP support team',
            subtitle: 'Simplify how you work',
          },
        },
        security: {
          title: '20 years of security and data protection',
          p: 'In tech world years, two decades equates to centuries. With that experience comes a deep knowledge of data security. Because we use the highest standard of bank-level encryption, your data is kept secure from any breaches.',
        },
      },
      neatFeatures: {
        main: {
          title: 'Smart Receipt Organizer: Automate Expense Tracking in Minutes',
          subtitle: 'Eliminate manual entry with our paperless document management system that captures, categorizes, and organizes receipts effortlessly.',
          smallPrint: 'Neat is a yearly subscription where you can add on solutions.',
          descriptionImgOne: 'Declutter with clear organization',
          descriptionImgTwo: 'Manage every type of file efficiently',
          altImgOne: 'Organize files',
          altImgTwo: 'All files',
        },
      },
      notFound: {
        h2: 'Oh No! The page you requested could not be found.',
        popular: 'Popular Pages:',
        links: {
          support: 'Neat’s Support Center',
          plansAndPricing: 'Plans and Pricing',
          blog: 'Neat’s Blog',
          contactUs: 'contact us',
          cannotFind: 'If you can’t find what you’re looking for, {link}.',
        },
      },
      policies: {
        email: 'Email Preferences',
        privacy: 'Privacy Policy',
        salesTax: 'Sales Tax Policy',
        terms: 'Terms & Conditions',
      },
      pricing: {
        header: {
          title: 'Transform the way you manage and organize your home or business',
        },
        faq: {
          title: 'Frequently Asked Questions',
          notReady: {
            title: "I'm not ready to make a decision. Do you offer a free trial?",
            p: "Yes, Neat offers a free 14-day trial. During those 14 days, you'll receive full access to the standard Neat plan. After the trial, you can continue with Neat or cancel risk-free. Click the link below to start your free trial today!",
          },
          subscription: {
            title: 'Does Neat Require a Subscription?',
            p: 'Yes, Neat offers affordable subscription plans to give you access to our full suite of features. Choose between monthly and annual billing options.',
          },
          cost: {
            title: 'How Much Does Neat Cost',
            p: 'Neat\'s pricing starts at $200/year, with optional add-ons like Automated Insights (+$150/year) and VIP Service (+$50/year). You can also try Neat for free before committing.',
          },
          moneyBack: {
            title: 'Does Neat offer a money-back guarantee?',
            p: 'Yes, if you decide that Neat is not the right solution for you, Neat offers a full 30-day money-back guarantee.',
          },
          receiptsCost: {
            title: 'How Much Are Neat Receipts?',
            p: 'Neat allows unlimited receipt scanning and storage based on your plan. No hidden fees—just simple, transparent pricing.',
          },
          support: {
            title: 'What kind of support services does Neat come with?',
            p: 'Neat comes with unlimited email and chat support. Also, you will have access to our Help Center Knowledge Base. You will need to purchase VIP Service if you want unlimited phone and the ability to schedule 1:1 training.',
          },
          storage: {
            title: 'How much document storage do I get a month?',
            p: 'Neat offers unlimited monthly storage.',
          },
          payMonthly: {
            title: 'Can I pay monthly?',
            p: 'No, Neat does not offer a monthly payment plan. All plans are billed yearly.',
          },
          insightsAndVip: {
            title: 'Can I purchase Neat + Automated Insights + VIP Service?',
            p: 'Yes, if you click on any Buy Now button, you will be able to select which solutions you want. Just remember, you cannot purchase Automated Insights or VIP Service without a Neat subscription.',
          },
        },
        offers: {
          title: 'Enhance your base subscription',
          restriction: 'Cannot purchase without a Neat subscription',
          restrictionNeatHome: 'Cannot purchase without a NeatHome subscription',
          buyCta: 'Buy Neat + {type}',
          buyNeatHomeCta: 'Buy NeatHome + {type}',
          learnMoreCta: 'Learn more about {type} →',
          vipService: {
            title: 'VIP Service',
            subtitle: 'Neat + $50/year',
            description: 'Everything you need, plus premium help from our specialized support team.',
            li1: '1:1 training guided by Neat Experts',
            li2: 'Dedicated support team so you can skip the line',
            li3: 'Early access to new features',
            li4: 'Exclusive offers',
          },
          automatedInsights: {
            title: 'Automated Insights',
            subtitle: 'Neat + $150/year',
            description: 'Gain valuable insights into your finances with real-time accounting and expense reporting.',
            li1: 'Import bank account activity',
            li2: 'Automatic accounting reports',
            li3: 'Real-time insights and trends',
            li4: 'Pair receipts with expenses',
            li5: 'Send custom invoices',
          },
          vipNeatHomeService: {
            title: 'VIP Service',
            subtitle: 'NeatHome + $50/year',
            description: 'Everything you need, plus premium help from our specialized support team.',
            li1: '1:1 training guided by Neat Experts',
            li2: 'Dedicated support team so you can skip the line',
            li3: 'Early access to new features',
            li4: 'Exclusive offers',
          },
        },
      },
      receiptDocumentScanners: {
        main: {
          subtitle: 'Compatible Receipt & Document Scanners.',
          description: 'Neat works with any TWAIN compliant scanner.',
          viewScanners: 'View All Compatible Scanners',
        },
      },
      renew: {
        featuresSection: {
          trackReceipts: {
            title: 'Track Receipts Everywhere',
            text: 'Capture receipts, invoices, and so much more with the snap of a picture. Then upload them straight to Neat using the app. Even email, drag and drop documents into Neat, or import with a compatible scanner.[br]You’ll always have access to your documents in Neat.',
          },
          dataExtraction: {
            title: 'Data Extraction',
            text: 'Reduce manual data entry with Neat’s powerful, patented OCR technology that accurately extracts key information from your document and turns it into usable data allowing you to enter receipts quickly and accurately.',
          },
          dataVerification: {
            title: 'Data Verification',
            text: 'Your receipt items are processed using Neat’s unique data identification technology and data is extracted with 99% accuracy.',
          },
          organizeFiles: {
            title: 'Organize Files Your Way',
            text: 'Organize files by expense type, tax category, and more. Quickly find files with our keyword search and filtering capabilities.',
          },
        },
      },
      security: {
        main: {
          title: 'Security',
          subtitle: 'Keeping Your Information Secure is Our Top Priority.',
          description: 'Neat uses best-in-class security measures to keep your data protected and safe.',
        },
      },
      taxPrep: {
        main: {
          integrationsCta: 'See All Integrations',
          title: 'Taxes',
          subtitle: 'The Best App to Scan Receipts for Taxes – Maximize Your Deductions',
          description: 'Neat simplifies tax prep by scanning, organizing, and categorizing receipts automatically. Never miss a deduction and keep your records audit-proof.',
          stayOrganized: {
            title: 'Stay Organized Year-Round with Smart Receipt Scanning',
            p: '<strong>Throw away those old accordion folders.</strong> With Neat, you can scan, snap a picture, email, or drag and drop documents to digitize them and make them keyword searchable automatically. Then, organize your files however you like. Want to automatically tag items by expense type? Done. Want to make notes on specific expenses? No problem. Neat works around your organizational style.',
          },
          checkReceipts: {
            title: 'Check Receipts Against Bank Transactions',
            p: '<strong>Have confidence that all of your transactions are centralized and accurate.</strong> No need to reconcile off of a bank statement. Connect to any of +10,000 financial institutions to match receipts and invoices directly to your bank or credit card transactions.',
          },
          fileTaxes: {
            title: 'File Your Taxes Quickly (And Accurately)',
            p: '<strong>Easily send expenses to your tax or accounting software.</strong> Map expenses a single time to match your QuickBooks preferences, and incoming data will be automatically coded. Export tax categories, expenses, and document images to tax software like TurboTax to eliminate the need to type in data.',
            cta: 'View All Integrations',
          },
          communicate: {
            title: 'Easily Communicate With Your Accountant',
            p: '<strong>Tired of long email chains?</strong> Send items to your accountant or tax preparer directly from Neat. Every item and folder in Neat also allows you to add and receive comments, making collaboration a breeze.',
          },
        },
      },
      transactionStreaming: {
        header: {
          title: 'Reconcile',
          subtitle: 'Reconciliation Software with Document Matching – Simplify Your Financial Workflow',
          description: 'Neat\'s smart reconciliation software with document matching connects transactions to receipts and invoices, reducing errors and saving you time.',
        },
        reconcile: {
          cta: 'Using Neat for tax prep',
        },
      },
      vipService: {
        features: {
          scheduleTraining: 'Tell us what topics you would like to cover during the session and let our Neat Experts guide you through making the most out of Neat.[br]1:1 training includes:',
          supportTeam: 'Cut the line and get priority phone, chat, and email support. Our dedicated VIP support team will prioritize your needs and provide exceptional care for all your customer service and technical support needs.[br][br]Our dedicated VIP support team is available M-F 9:00am-8:00pm EST',
          exclusiveOffers: 'Get early access to new features in beta, as well as exclusive offers to share with friends and family!',
          welcomeEmail: 'A welcome email will be sent with detailed information on how to schedule your 1:1 training and contact your dedicated support team.',
        },
      },
      expenseManagementMobileApp: {
        features: {
          transactionsInApp: 'Effortlessly connect your bank accounts, credit cards, and digital wallets into one powerful dashboard. Edit transactions with a tap, categorize expenses instantly, and gain total control over your financial narrative.',
          docCaptureImport: 'Our mobile app transforms your smartphone into a scanning powerhouse. Snap crystal-clear pictures of receipts and invoices instantly within the mobile app, turning your device into a financial documentation tool with just one click. Beyond camera capture, you can also seamlessly import documents directly from your device\'s photo gallery.',
          manageDocuments: 'Quickly review transactions and accounts from anywhere—in line, waiting, or spare moment. Effortlessly reconcile financial records by matching streamed transactions with uploaded receipts.',
          accessOrganizeDocs: 'Take charge of your documents on the go with the Neat mobile app\'s intuitive file management tools. Share PDFs, move items, send files to trash, duplicate folders, and copy documents—all within the mobile app\'s powerful interface. Your digital filing cabinet has never been more flexible.',
          easySearching: 'Find any document instantly with Neat\'s powerful search functionality. Quickly locate receipts, invoices, and files using keywords, dates, or categories, transforming document retrieval from a tedious task into a seamless, lightning-quick experience.',
        },
      },
      digitalFilingCabinet: {
        features: {
          multipleWaysToScan: 'Scan any kind of document with our mobile app, use a traditional scanner, through email or simply dragging and dropping from a computer. Eliminate the burden of stacks of paper documents and scan the way you want your process to be.',
          organizeDoc: 'Organize files by type, category, and more. Keep your personal documents safe, accessible, and organized. No more misfiling or lost paperwork. Digitally file your important records, easily locate them, and automate the process for worry-free document management.',
          autoFilingDocs: 'Neat’s powerful, patented technology allows you to capture your data from documents and help with categorization. Organize files with guided workflows with suggested matching to make filing easy.',
        },
        faq: {
          title: 'Frequently Asked Questions',
          cabinetUsedFor: {
            title: 'What can a digital filing cabinet be used for?',
            p: 'You can have a digital filing cabinet for home and/or business to act as a virtual system to store and organize documents such as receipts, legal documents, tax-related documents, wills and anything of documentation that is valuable to you.',
          },
          accessOnPhone: {
            title: 'Can I access Neat on my mobile phone?',
            p: 'Yes, Neat has a mobile app available on iOS or Google Play. Take photos of your documents straight from your phone. It\'s easy to organize all of your documents through our mobile application.',
          },
          storagePerMonth: {
            title: 'How much document storage do I get a year?',
            p: 'Neat offers unlimited yearly storage.',
          },
          scannersToUse: {
            title: 'What traditional scanners could I use to scan paper documents?',
            p: 'Neat works with any TWAIN compliant scanner, which includes most scanners on the market today. Additionally, Neat works with most major manufacturers to ensure their devices work seamlessly with Neat’s software. Compatible scanners include, but not limited to other TWAIN compliant scanners, ScanSnap, Ricoh, Brother & Canon.',
          },
          supportAvailable: {
            title: 'I need help with my digital filing cabinet is customer support available?',
            p: "Neat comes with unlimited email and chat support. Also, you will have access to our Help Center Knowledge Base. You will need to [a href='/vip-service']purchase VIP Service[/a] if you want unlimited phone and the ability to schedule 1:1 training.",
          },
        },
      },
      trackReceipts: {
        faq: {
          title: 'Frequently Asked Questions',
          imagesAccepted: {
            title: 'Are receipt images accepted by the IRS and what are the rules?',
            p: 'Absolutely. Digital receipts and scans are entirely acceptable to the IRS as long as they are legible, complete of all essential data, and accessible upon request. In fact, the IRS encourages electronic storage, provided the system is reliable and secure such as Neat.',
          },
          whatIsOcr: {
            title: 'What is OCR and how does it work?',
            p: 'OCR stands for Optical Character Recognition. Its a technology that reads text from images or scanned documents and transforms every word into keyword searchable text. For example, if you scan a receipt, Neat\'s OCR transforms the words and numbers into text you can search and copy.',
          },
          capturedOnReceipt: {
            title: 'What is captured on a receipt for data entry and organization?',
            p: "Date, Amount, Vendor, Sales Tax, Payment Type, Expense category, plus you can add your own custom classifications to a file. Find out more about the anatomy of a [a href='https://my.demio.com/ref/Bxl8lpnO6jFrH9Eu']Neat file[/a].",
          },
          howManyReceipts: {
            title: 'How many receipts can I scan and track?',
            p: 'Unlimited yearly storage.',
          },
          receiptsIntoNeat: {
            title: 'How do I get my receipts into Neat?',
            p: "There are many ways to get items into Neat such as:[br]• Snap a picture of your items with the [a href='https://support.neat.com/mobileapp/capture-items-with-the-neat-mobile-app']Neat Mobile App[/a].[br]• Email items directly to your Neat account using Neat’s [a href='https://neatcompany.helpdocs.io/neatapp/email-in-feature-in-neat']Neat Cloud email address feature[/a].[br]• [a href='https://neatcompany.helpdocs.io/neatapp/import-items-into-neat']Import items[/a] from your computer directly into New Neat.[br]• Scan items into Neat using the [a href='https://neatcompany.helpdocs.io/scanutility/neat-scan-utility-faq']Desktop Scan Utility[/a].",
          },
          neatOnMobile: {
            title: 'Can I access Neat on my mobile phone?',
            p: 'Yes, Neat has a mobile app available on iOS or Google Play. Take photos of your receipts straight from your phone. It\'s easy to organize all of your receipts through our mobile application.',
          },
          scannersForReceipts: {
            title: 'What traditional scanners could I use to scan receipts?',
            p: 'Neat works with any TWAIN compliant scanner, which includes most scanners on the market today. Additionally, Neat works with most major manufacturers to ensure their devices work seamlessly with Neat’s software. Compatible scanners include, but not limited to other TWAIN compliant scanners, ScanSnap, Ricoh, Brother & Canon.',
          },
          smartCategorization: {
            title: 'How does Neat\'s Smart Categorization work with my scanned receipts?',
            p: 'Smart Categorization helps speed up your upload workflow and improves accuracy by learning from how you’ve categorized receipts in the past. It automatically applies your preferred categories to recognized vendors based on your previous actions. The more you use it, the smarter and more personalized it becomes.',
          },
          integrateWithSoftware: {
            title: 'Can Neat\'s receipt scanning integrate with accounting software I already use?',
            p: 'Yes, Neat already has integration with accounting apps like Quickbooks, H&R Block, Quicken and TurboTax.',
          },
          addUsersToAccount: {
            title: 'Can I add users to my account to share access and collaborate?',
            p: 'Yes! You can share your account with up to 4 other users such as an accountant or employee. These users do not need to have their own active Neat account. These users will create their own login credentials to access your account and will have full access to view, edit, and comment on all files stored in any folder of your Neat account. If you wish to selectively share only a portion of your Neat account with another user, then you can share a specific folder and it\'s contents with a user.',
          },
          supportAvailable: {
            title: 'I need help with Neat & receipt tracking is customer support available?',
            p: "Neat comes with unlimited email and chat support. Also, you will have access to our Help Center Knowledge Base. You will need to [a href='https://www.neat.com/vip-service']purchase VIP Service[/a] if you want unlimited phone and the ability to schedule 1:1 training.",
          },
        },
      },
      signUp: {
        create: { success: 'Successful order' },
        form: {
          selectPlan: {
            nextButton: 'Continue',
            baseTooltip: 'Neat base subscription is required to continue.',
            side: {
              features: {
                files: 'Unlimited file storage',
                'data-capture': 'Data capture with human verification',
                'unlimited-support': 'Unlimited email & chat support',
                expenses: 'Track your expenses',
                filter: ' Easily filter and search for documents',
                'file-sharing': 'File sharing and collaboration',
                encryption: 'Bank-level security encryption',
                accessible: 'Accessible from anywhere',
                'help-center': 'Access to our Help Center Knowledge Base',
              },
            },
          },
          authenticate: {
            accountHeading: 'Create your Neat account',
            heading: {
              buyNeat: 'Buy a plan today.<br></br><em>30-day money back</em><br></br>guarantee!',
              buyNeatHome: 'Buy NeatHome today.<br></br><em>30-day money back</em><br></br>guarantee!',
              trialNeat: 'Start your <em>FREE</em> 14-day,<br></br>risk-free trial',
              trialNeatHome: 'Start your <em>FREE</em> 14-day,<br></br>risk-free trial & access<br></br>NeatHome today!',
              trialNeatSubhead: "Access Neat's Base plan today.",
            },
            nextButton: 'Continue with Email',
            separator: 'or continue with email',
          },
          newUser: {
            heading: 'Create your account',
            subheading: "Let's set up your account details.",
            nextButton: 'Next Step: Payment Details',
          },
          billing: {
            submit: 'Finalize Purchase',
            addCoupon: 'Apply',
            removeCoupon: 'Remove',
            submitTrial: 'Start My FREE 14-Day Trial',
            paypal: 'Continue to PayPal',
          },
          existingUser: {
            welcomeBack: 'Welcome back!',
            resetPassword: 'Reset my password',
            greeting: 'Hi <strong>{firstName} {lastName}</strong>',
            redirectToNeat: 'Click here to redirect',
            existingUserRedirect: 'You can view and manage your subscription from the My Subscription setting within the app. You will be redirected in 10 seconds. If you are not redirected please click the link below.',
          },
          coupon: {
            removeCoupon: 'Remove Coupon',
          },
          upsell: {
            getVip: 'Yes, give me VIP Service',
          },
        },
        unexpectedError: 'Oops! We encountered an unexpected error and our engineers have been alerted. If the problem persists, please contact Neat customer support.',
        noCcAiVipError: 'It looks like you already have access to all the features of Neat + Automated Insights, sign-in to your account to get started.',
        requestValidationError: 'Oops! We encountered an unexpected error and our engineers have been alerted. If the problem persists, please contact Neat customer support for assistance placing your order.',
      },
      blog: {
        title: 'The Neat Small Business Blog',
        description: 'Insights, news, and resources to help inform all aspects of running a business.',
        featuredArticles: 'Featured Articles',
        popularArticles: 'Popular',
        recentArticles: 'Recent',
        navigation: {
          accounting: 'Accounting & Bookkeeping',
          taxTime: 'Tax Time',
          smallBusiness: 'Small Business Resources',
          contractor: 'Contractor Resources',
          news: 'Neat News',
          homeFinance: 'Home Finance',
        },
        readMore: 'Read More >',
      },
      freeTrial: {
        form: {
          submit: 'Start My 30-Day Free Trial',
          error: {
            orderFailed: 'There was an error placing the order. Please try again.',
          },
        },
        ctaText: 'Start Your 30-Day Free Trial',
      },
      newsletter: {
        title: 'Neat Monthly Newsletter',
        description: 'Product updates, bookkeeping insights, and upcoming webinars - delivered once a month.',
        hero: {
          heading: 'Neat Monthly Newsletter',
          subheading: 'Product updates, bookkeeping insights, and upcoming webinars - delivered once a month.',
          microCopy: 'One email per month. Unsubscribe anytime.',
        },
        latestIssue: {
          heading: 'Latest Issue',
          cta: 'Read the latest Newsletter',
        },
        archivePreview: {
          heading: 'Past Newsletters',
          cta: 'View all newsletters',
        },
        subscribeReminder: {
          heading: 'Like what you are reading? Get the next issue in your inbox.',
        },
        crossLinks: {
          webinarsHeading: 'Webinars',
          webinarsDescription: 'Live and on-demand sessions to help you get the most out of Neat.',
          webinarsCta: 'Browse Webinars',
          blogHeading: 'Blog',
          blogDescription: 'Tips, guides, and resources for small business owners.',
          blogCta: 'Visit the Blog',
        },
        archive: {
          title: 'Past Newsletters',
          readMore: 'Read More',
          back: 'Back',
        },
      },
    },
    placeholder: {
      email: 'Email',
    },
    templates: {
      success: 'Thanks! We hope you enjoy {templateCount, plural, one {this} other {these}} {templateType}.',
      checkboxLabel: 'I consent to receiving marketing communications from The Neat Company',
      emailLabel: 'Enter your email address to access your free {templateType}',
    },
  },
}
